import api, { ValidateAxiosError, } from '@/modules/api.service';
import { CreateAtuacaoDto, ReadAtuacaoDto, UpdateAtuacaoDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindAtuacaoDto } from '@/api.types.extra';

const endpoint = Endpoints.ATUACAO;

export async function createAtuacao(dto: CreateAtuacaoDto) {
  try {
    const response = await api.post(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a atuacao.');
  }
}

export async function readAtuacao(filters: FindAtuacaoDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadAtuacaoDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar atuacao(s).');
  }
}

export async function updateAtuacao(dto: UpdateAtuacaoDto) {
  try {
    const response = await api.put(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a atuacao.');
  }
}

export async function deleteAtuacao(id: number) {

  try {
    const response = await api.delete(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a atuacao.');
  }
}